// extracted by mini-css-extract-plugin
export default {"home":"changeOldPassword_home__ysl8V","home2":"changeOldPassword_home2__rJFgS","main":"changeOldPassword_main__dio9j"};